import React from 'react';
import { Pressable as RNPressable, ViewProps } from 'react-native';

type PressableProps = React.ComponentProps<typeof RNPressable>;
type PressableOpacityProps = Omit<PressableProps, 'style'> & {
  pressedOpacity?: number;
  style?: ViewProps['style'];
};

export default function Pressable(props: PressableProps) {
  return <RNPressable {...props} />;
}

export function PressableOpacity({ style, pressedOpacity = 0.5, ...props }: PressableOpacityProps) {
  return (
    <Pressable
      style={({ pressed }) => [
        {
          opacity: pressed ? pressedOpacity : 1.0,
        },
        style,
      ]}
      {...props}
    />
  );
}
